module.exports = __webpack_public_path__ + "static/img/courses-placeholder.70454d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/courses-placeholder.jpg
// module id = 595
// module chunks = 2